import React from 'react';

const DeviceStack = ({ 
  phoneImage, 
  tabletImage, 
  webImage, 
  theme 
}) => {
  return (
    <div className="device-stack-container">
      {/* Web/Laptop - Back layer, center */}
      <div className="device device-web">
        <div className="device-frame device-frame-web">
          <div className="device-screen">
            <img src={webImage} alt="Web App" />
          </div>
        </div>
      </div>

      {/* Tablet - Middle layer */}
      <div className="device device-tablet">
        <div className="device-frame device-frame-tablet">
          <div className="device-screen">
            <img src={tabletImage} alt="Tablet App" />
          </div>
        </div>
      </div>

      {/* Phone - Front layer */}
      <div className="device device-phone">
        <div className="device-frame device-frame-phone">
          <div className="device-screen">
            <img src={phoneImage} alt="Mobile App" />
          </div>
          <div className="device-home-indicator"></div>
        </div>
      </div>

      <style>{`
        .device-stack-container {
          position: relative;
          width: 100%;
          height: 580px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .device {
          position: absolute;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        /* Web/Laptop Device - Center, top */
        .device-web {
          z-index: 1;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }

        .device-frame-web {
          width: 480px;
          background: #1a1a2e;
          border-radius: 12px;
          padding: 8px;
          box-shadow: 
            0 25px 50px -12px rgba(0, 0, 0, 0.35),
            0 0 0 2px rgba(255, 255, 255, 0.08),
            0 50px 100px -20px rgba(0, 0, 0, 0.2);
          overflow: hidden;
        }

        .device-frame-web .device-screen {
          width: 100%;
          overflow: hidden;
          border-radius: 6px;
        }

        .device-frame-web .device-screen img {
          width: 100%;
          height: auto;
          display: block;
        }

        /* Phone Device - Left side, tilted left */
        .device-phone {
          z-index: 3;
          bottom: 120px;
          left: 0;
          transform: rotate(-6deg);
        }

        .device-frame-phone {
          width: 120px;
          background: #1a1a2e;
          border-radius: 20px;
          padding: 6px;
          box-shadow: 
            0 25px 50px -12px rgba(0, 0, 0, 0.5),
            0 0 0 1px rgba(255, 255, 255, 0.1);
          position: relative;
        }

        .device-frame-phone .device-screen {
          border-radius: 16px;
          overflow: hidden;
          background: #000;
        }

        .device-frame-phone .device-screen img {
          width: 100%;
          height: auto;
          display: block;
        }

        .device-home-indicator {
          position: absolute;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
          width: 36%;
          height: 3px;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 2px;
        }

        /* Tablet Device - Right side, tilted right, in front of web */
        .device-tablet {
          z-index: 2;
          bottom: 40px;
          right: 0;
          transform: rotate(6deg);
        }

        .device-frame-tablet {
          width: 220px;
          background: #1a1a2e;
          border-radius: 16px;
          padding: 10px;
          box-shadow: 
            0 25px 50px -12px rgba(0, 0, 0, 0.45),
            0 0 0 1px rgba(255, 255, 255, 0.1);
        }

        .device-frame-tablet .device-screen {
          border-radius: 8px;
          overflow: hidden;
          background: #000;
        }

        .device-frame-tablet .device-screen img {
          width: 100%;
          height: auto;
          display: block;
        }

        /* Hover effects */
        .device-stack-container:hover .device-web {
          transform: translateX(-50%) translateY(-10px);
        }

        .device-stack-container:hover .device-phone {
          transform: rotate(-6deg) translateX(-8px) translateY(-5px);
        }

        .device-stack-container:hover .device-tablet {
          transform: rotate(6deg) translateX(8px) translateY(-5px);
        }

        /* Responsive adjustments */
        @media (max-width: 1280px) {
          .device-stack-container {
            height: 500px;
          }

          .device-frame-web {
            width: 420px;
          }

          .device-frame-tablet {
            width: 195px;
          }

          .device-frame-phone {
            width: 110px;
          }
        }

        @media (max-width: 1024px) {
          .device-stack-container {
            height: 430px;
          }

          .device-frame-web {
            width: 360px;
          }

          .device-frame-tablet {
            width: 170px;
            padding: 8px;
            border-radius: 14px;
          }

          .device-phone {
            bottom: 100px;
            transform: rotate(-5deg);
          }

          .device-frame-phone {
            width: 95px;
            padding: 5px;
            border-radius: 16px;
          }

          .device-frame-phone .device-screen {
            border-radius: 12px;
          }

          .device-tablet {
            transform: rotate(5deg);
          }

          .device-stack-container:hover .device-phone {
            transform: rotate(-5deg) translateX(-6px) translateY(-4px);
          }

          .device-stack-container:hover .device-tablet {
            transform: rotate(5deg) translateX(6px) translateY(-4px);
          }
        }

        @media (max-width: 768px) {
          .device-stack-container {
            height: 360px;
            margin-top: 40px;
          }

          .device-frame-web {
            width: 300px;
            padding: 6px;
          }

          .device-frame-web .device-screen {
            border-radius: 5px;
          }

          .device-phone {
            bottom: 80px;
            transform: rotate(-4deg);
          }

          .device-frame-phone {
            width: 80px;
            padding: 4px;
            border-radius: 14px;
          }

          .device-frame-phone .device-screen {
            border-radius: 10px;
          }

          .device-tablet {
            bottom: 30px;
            transform: rotate(4deg);
          }

          .device-frame-tablet {
            width: 145px;
            padding: 6px;
            border-radius: 12px;
          }

          .device-frame-tablet .device-screen {
            border-radius: 6px;
          }

          .device-home-indicator {
            height: 2px;
            bottom: 3px;
          }

          .device-stack-container:hover .device-phone {
            transform: rotate(-4deg) translateX(-5px) translateY(-3px);
          }

          .device-stack-container:hover .device-tablet {
            transform: rotate(4deg) translateX(5px) translateY(-3px);
          }
        }

        @media (max-width: 640px) {
          .device-stack-container {
            height: 300px;
          }

          .device-frame-web {
            width: 250px;
            padding: 5px;
          }

          .device-phone {
            bottom: 65px;
          }

          .device-frame-phone {
            width: 68px;
            padding: 3px;
            border-radius: 12px;
          }

          .device-frame-phone .device-screen {
            border-radius: 9px;
          }

          .device-tablet {
            bottom: 25px;
          }

          .device-frame-tablet {
            width: 120px;
            padding: 5px;
            border-radius: 10px;
          }
        }

        @media (max-width: 480px) {
          .device-stack-container {
            height: 200px;
          }

          /* Hide web and tablet on small mobile - show only phone */
          .device-web,
          .device-tablet {
            display: none;
          }

          /* Center and enlarge phone for mobile hero */
          .device-phone {
            position: relative;
            bottom: auto;
            left: auto;
            transform: none;
          }

          .device-frame-phone {
            width: 140px;
            margin: 0 auto;
            padding: 5px;
            border-radius: 16px;
          }

          .device-frame-phone .device-screen {
            border-radius: 12px;
          }

          .device-home-indicator {
            display: block;
            height: 3px;
            bottom: 4px;
          }

          .device-stack-container:hover .device-phone {
            transform: none;
          }
        }

        @media (max-width: 320px) {
          .device-stack-container {
            height: 180px;
          }

          .device-frame-phone {
            width: 120px;
            padding: 4px;
            border-radius: 14px;
          }

          .device-frame-phone .device-screen {
            border-radius: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default DeviceStack;